var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-link-create',{attrs:{"client-id":_vm.clientId,"back-route":{ name: 'client-content-links', params: { clientId: _vm.clientId } }}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/content/links/create.vue?vue&type=template&id=4564412f
// module id = z2uq
// module chunks = 0